export default __webpack_public_path__ + "static/media/features-thumb-3.4fabd555.png";